export default __webpack_public_path__ + "static/media/todo.fb2e510d.png";